import { render, staticRenderFns } from "./DepartDataruleModal.vue?vue&type=template&id=85bc8eb6&scoped=true"
import script from "./DepartDataruleModal.vue?vue&type=script&lang=js"
export * from "./DepartDataruleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bc8eb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85bc8eb6')) {
      api.createRecord('85bc8eb6', component.options)
    } else {
      api.reload('85bc8eb6', component.options)
    }
    module.hot.accept("./DepartDataruleModal.vue?vue&type=template&id=85bc8eb6&scoped=true", function () {
      api.rerender('85bc8eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DepartDataruleModal.vue"
export default component.exports